import { useUserSettings } from '../../../../utils/use-user-settings';
import DecomLogsGrid from './decom-log-grid';

export default function DecomLogTab() {
  const { viewType } = useUserSettings();

  return <DecomLogsGrid key={viewType.decomLogsGridStates?.activeGridState} />;
}
